
// Swap-replace random shuffle
export function shuffled<T>(array: T[]): T[] {
    const newArr = [...array];

    for (let i = 0; i < newArr.length; i++) {
        const rndIdx = (Math.random() * newArr.length) | 0;

        const tmp = newArr[i];
        newArr[i] = newArr[rndIdx];
        newArr[rndIdx] = tmp;
    }

    return newArr;
}